import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import { AllRightsReserved } from "../common/all-rights-reserved";
import { FooterBaseSection } from "../footer-base-section";

export const FunnelFooter: React.FC = () => {
  const { features } = useAppContext();

  return (
    <FooterBaseSection>
      <AllRightsReserved company_name={features.DISPLAY_NAME ?? ""} />
    </FooterBaseSection>
  );
};
